import { TypeBase } from '../TypeBase'
import { Default } from '@master/annotation/Default'
import { MaxChar } from '@master/annotation/MaxChar'
import { InputMaxChar } from '@master/enum/MaxCharsEnum'
import { isEmpty, isNil } from 'lodash/fp';
/**
 * AKA Customer Knowledge Assessment
 * By default, completed, *_specify is used by both
 * client 1 and 2
 */
export default class CKA extends TypeBase {
  @Default(false)
  ckaCompleted = false // was complete_cka

  educationList: string[] = []

  @MaxChar(InputMaxChar.SMALL)
  educationSpecify = ''

  higherEducation = ''
  investmentExperience = ''

  investmentList: string[] = []

  @MaxChar(InputMaxChar.SMALL)
  investmentSpecify = ''

  ckaMet = '' // was ckaMet
  otherInvestmentExp = ''
  otherProfessional = ''

  @MaxChar(InputMaxChar.SMALL)
  profSpecify = ''

  professionalList: string[] = []

  professionalQualification = ''
  otherProfessionalQualification = ''
  workExperience = ''

  workList: string[] = []

  @MaxChar(InputMaxChar.SMALL)
  workSpecify = ''

  eLearning = ''
  eLearningSpecify = ''

  ckaCarOutcome = {}
  isNoResult() {
    return (isNil(this.higherEducation) || isEmpty(this.higherEducation))
      && (isNil(this.professionalQualification) || isEmpty(this.professionalQualification))
      && (isNil(this.investmentExperience) || isEmpty(this.investmentExperience))
      && (isNil(this.workExperience) || isEmpty(this.workExperience))
  }
  constructor (type: 'client_0' | 'client_1' = 'client_0') {
    super(`${type}`)
  }

  reset () {
    this.ckaCompleted = false
    this.educationList = []
    this.educationSpecify = ''
    this.higherEducation = ''
    this.investmentExperience = ''
    this.investmentList = []
    this.investmentSpecify = ''
    this.ckaMet = ''
    this.otherInvestmentExp = ''
    this.otherProfessional = ''
    this.profSpecify = ''
    this.professionalList = []
    this.professionalQualification = ''
    this.otherProfessionalQualification = ''
    this.workExperience = ''
    this.workList = []
    this.workSpecify = ''
    this.eLearning = ''
    this.eLearningSpecify = ''
    this.ckaCarOutcome = {}
  }

  isAllQuestionAnwsered() {
    const isAllQuestionAnwsered = [
      this.higherEducation,
      this.professionalQualification,
      this.investmentExperience,
      this.workExperience,
    ].every((val) => !isNil(val) && !isEmpty(val));
    return isAllQuestionAnwsered;
  }
}
